import React, { forwardRef } from 'react'

import clsx from 'clsx'

import classes from './Paper.module.scss'

/** @type {import("./types").default} */
const Paper = forwardRef(({ children, className, elevation = 1, square, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={clsx('Paper', className, classes.root, classes[`elevation-${elevation}`], square && classes.square)}
      {...props}
    >
      {children}
    </div>
  )
})

export default Paper
